import { LoggerInterface } from "./logger.interface";
import * as moment from 'moment';

export type LogType = 'Error' | 'Info';

interface LogEntry {
    type: LogType;
    message: string;
    data: LoggerInterface;
}

export class RestLogger {
    private readonly APP_FIELD = 'Application';
    private readonly ENV_FIELD = 'Environment';
    private readonly VERSION_FIELD = 'Version';
    private readonly BROWSER_FIELD = 'Browser';
    private readonly ELAPSED_MS_FIELD = 'ElapsedMilliseconds';
    private readonly REQUEST_PATH_FIELD = 'RequestPath';
    private readonly URL_FIELD = 'Url';
    private readonly APP_STATE_FIELD = 'AppState';

    private buffer: LogEntry[] = [];

    constructor(private appName: string, private logEndpoint: string) {

    }

    public log(type: LogType, message: string, data: LoggerInterface) {
        let entry = {
            type: type,
            message: message,
            data: data
        };

        let logData = this.buildLogString(entry);
        this.postLog(logData);
    }

    postLog(logData: string) {        
    }

    private buildLogString(entry: LogEntry): string {
        const body = this.buildBodyChunk(entry);

        return `${body}\n`;
    }    

    private buildBodyChunk(entry: LogEntry) {
        const { type, message, data } = entry;
        const level = type;
        const date = moment();
        const messageTemplate = this.getMessageTemplate();
        const fields = this.getFields(data);
        const body = {
            'timestamp': `${date.toISOString()}`,
            level,
            messageTemplate,
            message,
            fields
        };

        return JSON.stringify(body);
    }

    private getMessageTemplate() {
        const fields: string[] = [
            this.APP_FIELD,
            this.ENV_FIELD,
            this.VERSION_FIELD,
            this.BROWSER_FIELD,
            this.ELAPSED_MS_FIELD,
            this.REQUEST_PATH_FIELD,
            this.URL_FIELD,
            this.APP_STATE_FIELD
        ];
        const template = fields.map((field) => `{${field}}`).join(' - ');

        return template;
    }

    private getFields(data: LoggerInterface) {
        return {
            [this.APP_FIELD]: this.appName,
            [this.ENV_FIELD]: data.environment,
            [this.VERSION_FIELD]: data.appVersion,
            [this.BROWSER_FIELD]: data.browser,
            [this.ELAPSED_MS_FIELD]: data.elapsedTime,
            [this.REQUEST_PATH_FIELD]: data.requestPath,
            [this.URL_FIELD]: data.url
        };
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/logger/rest-logger.ts